module.exports = __webpack_public_path__ + "img/1457472184.90dd47a4.jpg";